import { TemplatePage } from './types';

const liveStreamingHoneycombTheme: TemplatePage = {
  header: {
    color: '#CACACA',
    icon: 'images/video-templates/honeycomb_theme.jpg',
    title: 'Live Stream Templates — Honeycomb Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Honeycomb Theme',
    description_meta:
      'Give your live streams a professional look with Wave.video’s honeycomb-themed templates. Get a complete package of ' +
      'free video transitions & overlays.',
    description:
      'Make your live streams look stylish and professional using our pack of honeycomb-themed templates. ' +
      'Get a perfect set of pre-designed overlays, transition screens, and frames for multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live streaming honeycomb theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates for live streams, you will ' +
      'wow your viewers without much effort. Pick a set of templates that resonates with your style and easily make a few tweaks. ' +
      'You will create a unique and professional look for your live streams with no design background. Increase your ' +
      'brand recognition and grow your fanbase!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming honeycomb theme',
      search: { name: 'HoneycombTheme', tags: 'HoneycombTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamingHoneycombTheme;
